import { colors } from '@alixpartners/ui-components';
import styled from 'styled-components';

export const Breadcrumbs = styled.div`
	font-weight: 500;
	font-size: 12px;
	letter-spacing: 0.3px;
	color: ${colors.grey6};
	span {
		font-size: 12px;
	}
	span:hover {
		font-size: 12px;
		color: ${colors.grey9};
	}
	span:nth-child(1):hover {
		cursor: pointer;
	}
`;

export const ChartsWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 12px;
	margin: 8px 0 0 0;
`;
